import getCanInitiallyAutoplay from "selectors/device/getCanInitiallyAutoplay";
import { createSelector } from "reselect";

const getReceivedUserInteraction = (state) =>
  state.userInteraction.receivedUserInteraction;
const getIsOnChapter = (state) => state.route.params.chapterKey;
const getIsAutoplay = (state) => state.playerOptions.autoplay;

const getWaitingForInitialPlay = createSelector(
  getCanInitiallyAutoplay,
  getIsOnChapter,
  getReceivedUserInteraction,
  getIsAutoplay,
  (canInitiallyAutoplay, isOnChapter, receivedUserInteraction, isAutoplay) =>
    !canInitiallyAutoplay &&
    !receivedUserInteraction &&
    !(isOnChapter || isAutoplay),
);

export default getWaitingForInitialPlay;
